// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  QuestionWithAnswer,
} from "./types";


export default __t.row({
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.option(__t.timestamp()).name("updated_at"),
  deletedAt: __t.option(__t.timestamp()).name("deleted_at"),
  id: __t.string().primaryKey(),
  underwritableEntity: __t.uuid().name("underwritable_entity"),
  get question() {
    return QuestionWithAnswer;
  },
});
